import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { ShadowEvaluationLog } from 'app/shared/eventsOld/models';
import { TRANSACTION_QUERY_KEYS } from 'app/modules/transactions/queries/keys';
import {
  ActionEventExternalId,
  TxnEventExternalId,
  txnEventExternalId,
} from 'app/shared/types/eventExternalIds';
import { useHashedId } from 'app/shared/hooks/useHashedId';

export const useGetShadowEvaluationLog = (
  enabled?: boolean,
  eventExternalId?: TxnEventExternalId | ActionEventExternalId,
  // The cached route resolves via TxnEventFast only, so action events must stay
  // on the legacy path. Callers pass isTxnEvent=true only for txn events.
  isTxnEvent: boolean = false,
) => {
  // will always be set when query is issued
  const parsedExternalId = eventExternalId || txnEventExternalId('');
  const { hashedId, useHashed } = useHashedId(parsedExternalId);
  const useCached = isTxnEvent && useHashed;
  return useQuery({
    queryKey: TRANSACTION_QUERY_KEYS.getTxnShadowEvaluation(
      useCached ? hashedId : parsedExternalId,
    ),
    queryFn: () =>
      useCached
        ? get<ShadowEvaluationLog>(
            `/v1/txn-events/cached/${hashedId}/shadow_evaluation_log`,
          )
        : get<ShadowEvaluationLog>(
            `/v1/txn-events/${encodeURIComponent(parsedExternalId)}/shadow_evaluation_log`,
          ),
    enabled: Boolean(enabled && !!eventExternalId),
    initialData: {
      evaluation_id: '',
      event_id: txnEventExternalId(''),
      rule_executions: {},
    },
  });
};
